<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-toast></p-toast>

<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event); onReciveActionHead($event)"
  [actionsHead]="table.actionsHead"
></ami-table-actions>

<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>

<ng-container *ngIf="showOpenPurchaseOrderCreate">
  <pg-purchase-order-create
    [prueba]="prueba"
    (close)="showOpenPurchaseOrderCreate = false"
  ></pg-purchase-order-create>
</ng-container>

<ng-container *ngIf="showOpenPurchaseOrderUpdate">
  <pg-purchase-order-update
    [dataDocumentEdit]="dataDocumentEdit"
    (close)="showOpenPurchaseOrderUpdate = false"
  ></pg-purchase-order-update>
</ng-container>

<div *ngIf="dataDocument">
  <pg-purchase-order-detail
    [dataDocument]="dataDocument"
    (onHideData)="dataDocument = undefined"
  >
  </pg-purchase-order-detail>
</div>

<p-dialog
  header="Completar Orden de Compra"
  [(visible)]="displayResponsive"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw' }"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="footer">
    <div *ngIf="viewCompleteState">
      <p>
        Al aprobar la Orden de Compra no estará permitido realizar
        modificaciones a la Orden de Compra
      </p>
      <button
        (click)="approvePurchaseOrder()"
        pButton
        pRipple
        type="button"
        label="Aprobar Orden de Compra"
        class="p-button-success"
      ></button>
      <button
        (click)="rejectPurchaseOrder()"
        pButton
        pRipple
        type="button"
        label="Rechazar Orden de Compra"
        class="p-button-danger"
      ></button>
    </div>
    <div *ngIf="!viewCompleteState">
      <p style="text-align: left">
        Al completar la Orden de Compra, los productos serán enviados al almacén
        y no estará permitido realizar cambios a este documento. Es necesario
        completar la Recepción y Facturación del documento.
      </p>
      <button
        *ngIf="viewCompleteStateButton"
        (click)="completePurchaseOrder()"
        pButton
        pRipple
        type="button"
        label="Completar Orden de Compra"
        class="p-button-success"
      ></button>
    </div>
  </ng-template>
</p-dialog>
